import { render, staticRenderFns } from "./ProcedimentoListar.vue?vue&type=template&id=41c38922&scoped=true"
import script from "./ProcedimentoListar.vue?vue&type=script&lang=js"
export * from "./ProcedimentoListar.vue?vue&type=script&lang=js"
import style0 from "./ProcedimentoListar.vue?vue&type=style&index=0&id=41c38922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c38922",
  null
  
)

export default component.exports